module.exports = __webpack_public_path__ + "static/media/g-4-c.98f4a7b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-4-c.jpg
// module id = 1138
// module chunks = 33